export const PROMOTION_DISCOUNT_RATE = {
  MAX: 100,
  MIN: 0,
}

export const PROMOTION_EQUAL_PARTS_NUMBER = 10

export const PROMOTION_MIN_EQUAL_PARTS_NUMBER = 1

export const PROMOTION_COUPON_USAGE_STATUS = {
  RECEIVED: '2',
  USED: '3',
}
